import React, { createContext, useContext, useState } from 'react';

const LearningContext = createContext();

export const useLearning = () => {
    const context = useContext(LearningContext);
    if (!context) {
        throw new Error('useLearning must be used within a LearningProvider');
    }
    return context;
};

export const LearningProvider = ({ children }) => {
    const [learningData, setLearningData] = useState({
        aiID: null,
        singleTopic: null,
        mapped: null,
        learning: null,
        mainID: null,
        topicNo: null,
        uniqueId: null,
        roomID: null,
        assessmentExist: false,
        assessmentInfo: null,
    });

    const updateLearningData = (newData) => {
        setLearningData(prev => ({
            ...prev,
            ...newData
        }));
    };

    return (
        <LearningContext.Provider value={{ learningData, updateLearningData }}>
            {children}
        </LearningContext.Provider>
    );
};
